import { render, staticRenderFns } from "./AddEditVaultUser.vue?vue&type=template&id=4fcab1b2&"
import script from "./AddEditVaultUser.vue?vue&type=script&lang=js&"
export * from "./AddEditVaultUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports